import { createReducer, on, ActionReducer } from '@ngrx/store';
import { zefResetState } from '@zerops/zef/core';
import { trackTimeSeriesSubscriptionItem } from './time-series-base.utils';

/**
 * Generic time-series reducer creator
 */
export function createTimeSeriesReducer(config: {
  initialState: any;
  trackActionType: any;
  prefillActionType: any;
  successActionType: any;
  updateActionType: any;
  getSubscriptionName: (item: any) => string;
  transformData: (data: any, state: any) => any;
  getTrackedItems: (state: any) => any[];
  setTrackedItems: (state: any, items: any[]) => any;
  getData: (state: any) => any;
  setData: (state: any, data: any) => any;
}): ActionReducer<any> {
  
  return createReducer(
    config.initialState,

    on(config.trackActionType, (state: any, { data }: any) => {
      const currentTrackedItems = config.getTrackedItems(state);
      const newTrackedItems = trackTimeSeriesSubscriptionItem(
        currentTrackedItems,
        data,
        config.getSubscriptionName
      );
      return config.setTrackedItems(state, newTrackedItems);
    }),

    on(config.prefillActionType, (state: any, data: any) => {
      const currentData = config.getData(state);
      const transformedData = config.transformData(data, currentData);
      return config.setData(state, transformedData);
    }),

    on(config.successActionType, (state: any, { data }: any) => {
      const currentData = config.getData(state);
      const transformedData = config.transformData(data, currentData);
      return config.setData(state, transformedData);
    }),

    on(config.updateActionType, (state: any, data: any) => {
      const currentData = config.getData(state);
      const transformedData = config.transformData(data, currentData);
      return config.setData(state, transformedData);
    }),

    on(zefResetState, () => config.initialState)
  );
}

/**
 * Helper function to create standard time-series state management functions
 */
export function createTimeSeriesStateHelpers() {
  return {
    getTrackedItems: (state: any) => state.trackedItems,
    setTrackedItems: (state: any, items: any[]) => ({
      ...state,
      trackedItems: items
    }),
    getData: (state: any) => state.data,
    setData: (state: any, data: any) => ({
      ...state,
      data
    })
  };
}

/**
 * Standard time-series reducer configuration factory
 */
export function createStandardTimeSeriesReducerConfig(config: {
  initialState: any;
  trackActionType: any;
  prefillActionType: any;
  successActionType: any;
  updateActionType: any;
  getSubscriptionName: (item: any) => string;
  transformData: (data: any, state: any) => any;
}) {
  const stateHelpers = createTimeSeriesStateHelpers();
  
  return {
    ...config,
    ...stateHelpers
  };
}